import React from 'react'
import { Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const SkeletonsForm = () => (
  <Grid container spacing={3}>
    <Grid item xs={12} md={6}>
      <Skeleton variant="rect" height={56} />
    </Grid>
    <Grid item xs={12} md={6}>
      <Skeleton variant="rect" height={56} />
    </Grid>
    <Grid item xs={12} md={6}>
      <Skeleton variant="rect" height={56} />
    </Grid>
    <Grid item xs={12} md={6}>
      <Skeleton variant="rect" height={56} />
    </Grid>
    <Grid item xs={12}>
      <Skeleton variant="rect" height={200} />
    </Grid>
  </Grid>
)

export default SkeletonsForm
